import React from "react";
import { useParams } from "react-router-dom";
import { collegesDetails } from "../data/collegesDetails";
import SEO from '../components/SEO';
import { Link } from 'react-router-dom';

import FAQsSection from "../components/layout/FAQsSection";
import Navbar from "../components/layout/Navbar";
import HeroSection from "../components/layout/HeroSection";
import HighlightsStrip from "../components/layout/HighlightsStrip";
import AboutSection from "../components/layout/AboutSection";
import CoursesSection from "../components/layout/CoursesSection";
import FeeStructureSection from "../components/layout/FeeStructureSection"; // ADD THIS
import PlacementsSection from "../components/layout/PlacementsSection";
import Footer from "../components/layout/Footer";

export default function CollegeDetail() {
  const { slug } = useParams();

  if (!Array.isArray(collegesDetails)) {
    return <div style={{ padding: "40px" }}>College data not loaded.</div>;
  }

  const college = collegesDetails.find((c) => c.slug === slug);

  if (!college) {
    return (
      <div style={{ padding: "40px" }}>
        <h2>College not found</h2>
      </div>
    );
  }

  const generateCollegeSchema = (college) => {
    return {
      "@context": "https://schema.org",
      "@type": "EducationalOrganization",
      "name": college.name,
      "url": `https://www.collegeaggregator.com/college/${college.slug}`,
      "logo": `https://www.collegeaggregator.com${college.logo}`,
      "image": `https://www.collegeaggregator.com${college.image}`,
      "description": `${college.name} in ${college.location}. Offering courses in ${college.courses?.slice(0,3).map(c => c.stream).join(', ')}`,
      "address": {
        "@type": "PostalAddress",
        "streetAddress": college.location,
        "addressLocality": "Dehradun",
        "addressRegion": "Uttarakhand",
        "addressCountry": "IN"
      },
      "aggregateRating": college.rating ? {
        "@type": "AggregateRating",
        "ratingValue": college.rating.split('/'),
        "bestRating": "5",
        "ratingCount": "100"
      } : undefined,
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "Educational Programs",
        "itemListElement": college.courses?.map(course => ({
          "@type": "Offer",
          "itemOffered": {
            "@type": "Course",
            "name": course.name,
            "provider": {
              "@type": "EducationalOrganization",
              "name": college.name
            },
            "educationalLevel": course.level,
            "timeToComplete": course.duration,
            "offers": {
              "@type": "Offer",
              "price": course.fees || "Contact for details",
              "priceCurrency": "INR"
            }
          }
        }))
      }
    };
  };

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://www.collegeaggregator.com"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "Colleges",
        "item": "https://www.collegeaggregator.com/#colleges"
      },
      {
        "@type": "ListItem",
        "position": 3,
        "name": college.name,
        "item": `https://www.collegeaggregator.com/college/${college.slug}`
      }
    ]
  };

  const collegeSchema = generateCollegeSchema(college);
  const combinedSchema = [collegeSchema, breadcrumbSchema];
  


  return (
    <div className="college-detail-page">
  <SEO 
  title={`${college.name} Dehradun - Courses, Fees, Admission 2026`}
  description={`Complete details about ${college.name}...`}
  keywords={`${college.name}, ${college.slug}, colleges in dehradun`}
  canonical={`/college/${college.slug}`}  // ✅ THIS IS CORRECT
  ogImage={college.image}
  ogType="article"
  structuredData={combinedSchema}
  />

      
      <Navbar />
      <HeroSection college={college} />
      <HighlightsStrip college={college} />
      <AboutSection college={college} />
      <CoursesSection college={college} />
      <FeeStructureSection college={college} /> {/* ADD THIS LINE */}
      <PlacementsSection college={college} />
      <FAQsSection college={college} />


{/* Add this section just before <Footer /> */}
<section className="related-colleges">
  <h2>Similar Colleges in Dehradun</h2>
  <div className="related-grid">
    {collegesDetails
      .filter(c => c.slug !== college.slug)
      .slice(0, 3)
      .map(relatedCollege => (
        <Link 
          to={`/college/${relatedCollege.slug}`} 
          key={relatedCollege.slug} 
          className="related-card"
        >
          <img 
            src={relatedCollege.image} 
            alt={`${relatedCollege.name} campus`}
            loading="lazy"
          />
          <h3>{relatedCollege.name}</h3>
          <p>{relatedCollege.location}</p>
        </Link>
      ))}
  </div>
</section>


      <Footer />
    </div>
  );
}
